<template>
  <div class="block-datos-resumen cl">
    <div>
      <h3 class="title">Tomador</h3>

      <dl class="contenido">
        <dt>Num.Doc:</dt>
        <dd>{{ resumen.tomador.numDoc }}</dd>
        <span v-if="resumen.tomador.empresa">
          <dt>Razón social:</dt>
          <dd>{{ resumen.tomador.nombre }}</dd>
        </span>
        <span v-else>
          <dt>Nombre:</dt>
          <dd>{{ resumen.tomador.nombre }}</dd>
          <dt>Primer apellido:</dt>
          <dd>{{ resumen.tomador.ape1 }}</dd>
          <dt>Segundo apellido:</dt>
          <dd>{{ resumen.tomador.ape2 }}</dd>
          <span v-if="resumen.tomador.fecNacimiento">
            <dt>Fecha de nacimiento:</dt>
            <dd>{{ resumen.tomador.fecNacimiento | dateDDMMYYYY_slash }}</dd>
          </span>
        </span>
        <dt>Código postal:</dt>
        <dd>{{ resumen.codPostal }}</dd>
        <dt>Teléfono:</dt>
        <dd>{{ resumen.tomador.telefono }}</dd>
        <dt>E-mail:</dt>
        <dd>{{ resumen.tomador.email }}</dd>
        <span v-if="resumen.tomador.tipoEmpresa">
          <dt>Tipo de empresa:</dt>
          <dd>{{ resumen.tomador.tipoEmpresa }}</dd>
        </span>
        <span v-if="resumen.tomador.hijosMenores">
          <dt>Hijos menores de 14 años:</dt>
          <dd>{{ resumen.tomador.hijosMenores }}</dd>
        </span>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  store: ["step"],
  props: {
    resumen: {
      type: Object
    }
  }
};
</script>

<style></style>
